import moment from 'src/services/moment_instance';

export const MAX_BIRTHDATE_AGE_YEARS = 120;

export const GUEST_FIELD_ERRORS = {
  identification: 'La identificación debe ser solo números y tener entre 6 y 10 dígitos.',
  email: 'El correo electrónico no tiene un formato válido.',
  phone: 'El celular debe tener exactamente 10 dígitos y comenzar por 3 o 6.',
  birthdate: 'La fecha de nacimiento no es válida.',
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[36]\d{9}$/;
const IDENTIFICATION_RE = /^\d{6,10}$/;

export const digitsOnly = (value) => String(value ?? '').replace(/\D/g, '');

export const normalizeIdentification = (value) => digitsOnly(value).slice(0, 10);

export const normalizePhone = (value) => {
  let digits = digitsOnly(value);
  if (digits.startsWith('57') && digits.length === 12) digits = digits.slice(2);
  return digits.slice(0, 10);
};

export const normalizeEmail = (value) => String(value ?? '').trim();

export const birthdateForInput = (value) => {
  if (!value) return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const parsed = moment(s, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};

export const birthdateInputBounds = () => ({
  min: moment().subtract(MAX_BIRTHDATE_AGE_YEARS, 'years').format('YYYY-MM-DD'),
  max: moment().format('YYYY-MM-DD'),
});

export const isValidIdentification = (value) => IDENTIFICATION_RE.test(String(value ?? ''));

export const isValidPhone = (value) => PHONE_RE.test(String(value ?? ''));

export const isValidEmail = (value, { required = false } = {}) => {
  const email = normalizeEmail(value);
  if (!email) return !required;
  return EMAIL_RE.test(email);
};

export const isValidBirthdate = (value, { required = false } = {}) => {
  if (!value) return !required;
  const parsed = moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true);
  if (!parsed.isValid()) return false;
  if (parsed.isAfter(moment(), 'day')) return false;
  if (parsed.isBefore(moment().subtract(MAX_BIRTHDATE_AGE_YEARS, 'years'), 'day')) return false;
  return true;
};

export const sanitizeGuestField = (name, value) => {
  if (name === 'identification') return normalizeIdentification(value);
  if (name === 'phone') return normalizePhone(value);
  if (name === 'email') return String(value ?? '').trimStart();
  if (name === 'birthdate' && !(value instanceof Date)) return birthdateForInput(value) || value;
  return value;
};

export const emptyGuestFieldErrors = () => ({
  identification: false,
  email: false,
  phone: false,
  birthdate: false,
});

export const validateGuestFields = (
  { identification, email, phone, birthdate } = {},
  { emailRequired = false, birthdateRequired = false } = {}
) => {
  const errors = emptyGuestFieldErrors();
  const messages = [];
  const mark = (field, valid) => {
    if (valid) return;
    errors[field] = true;
    messages.push(GUEST_FIELD_ERRORS[field]);
  };

  mark('identification', isValidIdentification(identification));
  mark('email', isValidEmail(email, { required: emailRequired }));
  mark('phone', isValidPhone(phone));
  mark('birthdate', isValidBirthdate(birthdate, { required: birthdateRequired }));

  return { errors, messages };
};
